import type { ReactElement } from 'react';

import { Button } from '@xing-com/button';
import { Meta } from '@xing-com/typography';

import * as Styled from './card-action-group.styled';
import type { CardActionGroupProps } from './card-action-group.types';

export type { CardActionGroupProps } from './card-action-group.types';

export const CardActionGroup = ({
  action,
  activationUrl,
  cancellation,
  onActivate,
  promoted,
}: CardActionGroupProps): ReactElement => (
  <Styled.ActionGroup>
    <Button
      href={activationUrl}
      onClick={onActivate}
      variant={promoted ? 'primary' : 'secondary'}
      size="large"
    >
      {action}
    </Button>
    <Meta size="xsmall" lineHeight="dense" noMargin>
      {cancellation}
    </Meta>
  </Styled.ActionGroup>
);
